import img1 from "../images/features/01 Cash Canvas supports Unlimited Accounts & Multi-Currency.png";
import img2 from "../images/features/02 Cash Canvas Smart Budget and expenses tracker.png";
import img3 from "../images/features/03 Cash Canvas Debt and Credit Card Tracker.png";
import img4 from "../images/features/04 Cash Canvas Investment Tracking.png";
import savingGoals from "../images/features/05 Cash Canvas Savings Tracker.png";
import subscription from "../images/features/06 Cash Canvas Subscriptions Tracker.png";
import secure from "../images/features/07 Your Data is Yours.png";
import ai from "../images/features/08 personalised insights on your finances.png";


export const testimonials = [
  {
    name: "Alex P.",
    feedback: "Cash Canvas made managing my finances so much easier! The dashboard is intuitive and the insights are spot on.",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Samantha R.",
    feedback: "I love the budgeting tools and how I can track all my accounts in one place.",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    name: "Michael T.",
    feedback: "The investment tracking feature is a game changer for me.",
    avatar: "https://randomuser.me/api/portraits/men/65.jpg",
  },
];


export const steps = [
  {
    title: "Sign Up",
    description: "Create your free account in seconds.",
    icon: "📝",
  },
  {
    title: "Connect Accounts",
    description: "Securely link your bank, credit, and investment accounts.",
    icon: "🔗",
  },
  {
    title: "Set Goals",
    description: "Define your financial goals and let us help you achieve them.",
    icon: "🎯",
  },
  {
    title: "Track & Grow",
    description: "Monitor your progress and get actionable insights.",
    icon: "🚀",
  },
];

export const features = [
  {
    title: "Unlimited Accounts & Multi-Currency Support",
    description: "Manage money across borders and accounts with confidence.",
    image: img1,
    alt: "01 cash canvas All in one Financial Management",
    details: [
      "Track multiple income sources and expenses easily",
      "Multi-currency support with automatic currency conversion",
      "See your total account balance in your preferred currency",
    ],
    bg: "bg-gradient-to-tr from-[#e2bf9c]/60 to-[#0a363c]/10",
  },
  {
    title: "Smart Budget and expenses tracker",
    description: "Build a flexible, AI-powered budget that grows with your lifestyle.",
    image: img2,
    alt: "02 Personal Finance AI Insights with CashBot",
    details: [
      "Set and manage monthly budgets with payment frequency options",
      "Assign source accounts for each payment to track cash flow accurately",
      "View income allocation across spending, savings, debt, and investment",
      "Monitor budgeted vs. actual spend",
      "Auto-tag and track subscriptions & renewal dates",
    ],
    bg: "bg-gradient-to-tr from-[#0a363c]/10 to-[#e2bf9c]/60",
  },
  {
    title: "Debt Management",
    description: "Stay in control of loans, credit cards, and mortgages.",
    image: img3,
    alt: "06 Debt Management",
    details: [
      "Record all your debts and repayment schedules",
      "Track recurring payments, one-offs, and account sources",
      "Get an estimated payoff date and progress overview",
    ],
    bg: "bg-gradient-to-tr from-[#e2bf9c]/40 to-[#0a363c]/10",
  },
  {
    title: "Investment Tracking",
    description: "Stay informed on your portfolio value and performance in one place.",
    image: img4,
    alt: "05 Cashg Canvas InvestmentsTracking",
    details: [
      "Track stocks, ETFs, crypto, and managed funds",
      "Use document upload to auto-import your portfolio",
      "Monitor values and portfolio performance",
      "Receive smart insights from CashBot",
    ],
    bg: "bg-gradient-to-tr from-[#0a363c]/10 to-[#e2bf9c]/40",
  },
  {
    title: "Savings Goals",
    description: "Turn your dreams into savings milestones.",
    image: savingGoals,
    alt: "04 Cash Canvas Savings Tracking",
    details: [
      "Create unlimited savings goals from emergency funds to vacations",
      "Set target amounts and goal reach dates",
      "Track contributions, withdrawals, and goal progress",
      "Tag the account holding each contribution",
      "View your total savings with a smart breakdown (e.g., Mojo fund, car savings)",
      "AI-generated insights: savings rate, projected reach date, and more",
    ],
    bg: "bg-gradient-to-tr from-[#e2bf9c]/60 to-[#0a363c]/10",
  },
  {
    title: "Subscriptions Tracker",
    description: "Say goodbye to forgotten subscriptions.",
    image: subscription,
    alt: "07 Subscription Tracker",
    details: [
      "Log and track all your subscriptions and automatically include them in your budget",
      "Use custom live widgets to see upcoming subscription renewals or expiries",
      "Tag source accounts and track payments over time",
    ],
    bg: "bg-gradient-to-tr from-[#0a363c]/10 to-[#e2bf9c]/60",
  },
  {
    title: "Secure & Private",
    description: "Your data is yours, always.",
    image: secure,
    alt: "08 Secure and Private",
    details: [
      "End-to-end encryption",
      "We never sell your data",
      "Download and export your data",
      "Delete your data whenever you want",
    ],
    bg: "bg-gradient-to-tr from-[#e2bf9c]/40 to-[#0a363c]/10",
  },
  {
    title: "AI Insights with CashBot",
    description:
      "Use AI to know exactly what you want to know about your finances. NO accounting, spreadsheet or data analysis skills needed. Let AI take the heavy lifting off your shoulders.",
    image: ai,
    alt: "09 AI and Insights",
    details: [
      "Generate instant live smart widgets and financial reports through simple text requests",
      "Get personalized insights on your cash flow, savings, and investment strategy",
      "Stay ahead with predictive insights and spending trends",
    ],
    bg: "bg-gradient-to-tr from-[#0a363c]/10 to-[#e2bf9c]/40",
  },
];

export const faqs = [
  {
    question: "What is CashCanvas?",
    answer: "CashCanvas is a smart personal finance app that helps you track your income, expenses, savings, debt, and investments, all in one place. It’s powered by CashBot, the AI engine that delivers personalized insights to help you manage money better.",
  },
  {
    question: "What is a Canvas in CashCanvas?",
    answer: "A Canvas is your personal financial space. Think of it like a digital whiteboard, where you plan, track, and manage your money. Each Canvas can represent a unique goal, life area, or money system (like personal finances, couple finances, extended family finances (also known as black tax etc.)). You can create multiple Canvases to keep different parts of your financial life organized, and use tools like CashBot, charts, and customizable categories to bring each one to life.",
  },
  {
    question: "Is CashCanvas free to use?",
    answer: "Yes! CashCanvas offers a free tier with access to budgeting, savings, debt tracking, and AI insights (supported by non intrusive ads). You can upgrade to Premium for ad-free access and additional features like investment tracking and shared canvas for families or partners. Check our Pricing Page for a full comparison.",
  },
  {
    question: "What features are available in Premium?",
    answer: "Premium plans unlock:\nInvestment tracking (stocks, ETFs, crypto, funds)\nAd-free experience\nMortgage tracking\nShared canvas (for couples and families)\nFull access to CashBot AI reports and widgets\nPremium starts at just $4.49/month. Try it free for 30 days!",
  },
  {
    question: "Is CashCanvas safe and secure?",
    answer: "Yes. Your data is protected with end-to-end encryption. We never sell your data. We never see your data. All activity is processed securely using industry best practices. We’re fully compliant with modern web security standards.",
  },
  {
    question: "Can I use CashCanvas from anywhere?",
    answer: "Absolutely. CashCanvas is built for a global audience, with multi-currency support and exchange rate tracking. You can manage finances in your local currency or view everything in your preferred currency.",
  },
  {
    question: "Does CashCanvas have a mobile app?",
    answer: "Currently, CashCanvas is a web-first app optimized for all devices. You can access it from any phone, tablet, or computer via your browser. A mobile app is on our roadmap, stay tuned!",
  },
  {
    question: "How does CashBot AI work?",
    answer: "CashBot is your personal finance assistant, powered by GPTs. It:\nAnalyzes spending, saving patterns, investments and liabilities\nDelivers custom insights via smart widgets that can be pinned on your dashboard\nTells you whatever you want to know about your finances",
  },
  {
    question: "Can I invite family or a partner?",
    answer: "Yes! With Premium Duo and Family Premium plans, you can add multiple adult users and unlimited kid accounts. Share finances, track progress together, and assign responsibilities in a secure shared canvas.",
  },
  {
    question: "What if I want to keep my personal finances private in a shared plan?",
    answer: "With Premium Duo and Family Premium plans, you have the option to create shared canvas and private canvas. A private canvas cannot be seen or accessed by anyone else in your plan besides you.",
  },
  {
    question: "Can I connect to my bank?",
    answer: "No. At the moment CashCanvas does not support linking with bank accounts. You can manually update your account balances directly inside the app or log data by uploading transaction files. Bank sync features are coming soon.",
  },
  {
    question: "What happens if I cancel a Premium plan?",
    answer: "You won’t lose your data. You’ll revert to the Free plan, with ads and limited feature access. You can upgrade again anytime without starting over.",
  },
  {
    question: "Still have questions?",
    answer: "Reach out to support@mycashcanvas.com or connect with us on X, Reddit, Telegram, TikTok or Bluesky",
  },
];
